<script setup lang="ts">
import { VBreadcrumbs, VBreadcrumbsItem } from 'vuetify/components';

type BreadcrumbItem = {
    title: string;
    value?: string | number;
    disabled?: boolean;
    href?: string;
    to?: string | object;
};

type Props = {
    items: BreadcrumbItem[];
    divider?: string;
    activeColor?: string;
    activeClass?: string;
    bgColor?: string;
    color?: string;
    density?: 'default' | 'comfortable' | 'compact';
    disabled?: boolean;
    icon?: string;
    tag?: string;
    variant?: 'text' | 'plain';
    chips?: boolean;
};

type Emits = {
    'click:item': [item: BreadcrumbItem, index: number];
};

const props = withDefaults(defineProps<Props>(), {
    divider: 'mdi-chevron-right',
    density: 'default',
    disabled: false,
    tag: 'nav',
    variant: 'text',
    chips: false,
});

const emit = defineEmits<Emits>();

const handleItemClick = (item: BreadcrumbItem, index: number) => {
    if (!item.disabled && !props.disabled) {
        emit('click:item', item, index);
    }
};
</script>

<template>
    <VBreadcrumbs
        :items="items"
        :divider="divider"
        :active-color="activeColor"
        :active-class="activeClass"
        :bg-color="bgColor"
        :color="color"
        :density="density"
        :disabled="disabled"
        :icon="icon || undefined"
        :tag="tag"
        :variant="variant"
    >
        <template #item="{ item, index }">
            <VBreadcrumbsItem
                :disabled="item.disabled || disabled"
                :href="item.href"
                :to="item.to"
                :title="item.title"
                @click="handleItemClick(item, index)"
            >
                <slot
                    name="item"
                    :item="item"
                    :index="index"
                >
                    {{ item.title }}
                </slot>
            </VBreadcrumbsItem>
        </template>
    </VBreadcrumbs>
</template>
